import merge from 'lodash/merge'

import { type TemplateData } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import { CouponBlockModule } from '../blocks/CouponSection'
import { CTAButtonBlockModule } from '../blocks/CTAButton'
import { TextBlockModule } from '../blocks/TextSection'
import { type EmailSectionCreate, type CampaignResourceCreate } from '../types'

const i18n = i18nPlugin.global

export const offerTemplate = async (
  brandId: string
): Promise<TemplateData<CampaignResourceCreate, EmailSectionCreate>> => ({
  blocks: [
    merge(
      TextBlockModule.createData({
        brandId,
        type: 'heading',
      }),
      {
        data: { text: i18n.t('email-builder.defaults.coupon.heading') },
      }
    ),
    merge(
      TextBlockModule.createData({
        brandId,
        type: 'paragraph',
      }),
      {
        data: { text: i18n.t('email-builder.defaults.coupon.paragraph') },
      }
    ),
    CouponBlockModule.createData({
      brandId,
      type: 'coupon',
    }),
    merge(CTAButtonBlockModule.createData({ brandId, type: 'cta' })),
  ],
  resource: {
    brandId,
    locationId: null,
    name: i18n.t('email-builder.defaults.coupon.subject'),
    sections: [],
    subject: i18n.t('email-builder.defaults.coupon.subject'),
  },
})
